import { client } from '../../../../../common-utils/libraries/axios/axios';
import { ORGANIZATION } from '../apiUrls';
import { replaceParameters } from '../../../../../common-utils/functions/restUtils';

/**
 * @param data
 * @returns {Array}
 */
function mapResponseData(data) {
    return data;
}

const queryGetSimAlerts = (organizationId, enabled) => {
    return {
        queryKey: [ORGANIZATION.SIM_ALERTS.queryKey, organizationId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(ORGANIZATION.SIM_ALERTS.url, { uuid: organizationId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetSimAlerts;
